export default __webpack_public_path__ + "static/media/pic48.7d966f00.jpg";